import React from "react";
import { TableRow, TableCell, Chip } from "@mui/material";
import { datetimeSimplifier } from "../../../redux/conversation/conversationSlice";
import { getObjectTargetName, ObjectTarget } from "../../../app/permissions";
import { getMessagePriorityColor, getMessagePriorityName } from "../../../redux/conversation/messagePriority";
import { getOrRetrieveNamedObject, selectObjectCache } from "../../../redux/object/objectCacheSlice";
import { useAppDispatch } from "../../../app/hooks";
import { MassiveMessage } from "../../../redux/conversation/massive/massiveMessageSlice";
import { useSelector } from "react-redux";

interface MassiveMessageRowProps {
  row: MassiveMessage;
  open: (row: MassiveMessage) => void;
}

const MassiveMessageRow = (props: MassiveMessageRowProps) => {
    const row = props.row;
    const dispatch = useAppDispatch();
    const cache = useSelector(selectObjectCache);

    // const school = getOrRetrieveNamedObject(dispatch, cache, ObjectTarget.SCHOOL, `${row.schoolId}`);
    // const classroom = row.classroomId ?
    //     getOrRetrieveNamedObject(dispatch, cache, ObjectTarget.CLASSROOM, `${row.classroomId}`)
    //     : undefined;
    const target = getOrRetrieveNamedObject(dispatch, cache, row.target, `${row.targetId}`);
    const user = getOrRetrieveNamedObject(dispatch, cache, ObjectTarget.USER, `${row.userId}`);

    const open = () => {
        props.open(row);
    };

    return (
        <TableRow key={row.id}>
            {/* <TableCell align="left">{school?.display ?? row.schoolId}</TableCell> */}
            {/* <TableCell align="left">{classroom?.display ?? row.classroomId}</TableCell> */}
            <TableCell align="left" onClick={open}>{getObjectTargetName(row.target)}</TableCell>
            <TableCell align="left" onClick={open}>{target?.display ?? row.targetId}</TableCell>
            <TableCell align="left" onClick={open}>
                <Chip
                    sx={{ 
                        width: "100px",  
                        color: (theme) => getMessagePriorityColor(theme, row.messagePriority).contrastText,
                        border: (theme) => `1px solid ${getMessagePriorityColor(theme, row.messagePriority).contrastText}`,
                        backgroundColor: (theme) => getMessagePriorityColor(theme, row.messagePriority).main,
                    }}
                    label={getMessagePriorityName(row.messagePriority)}
                    variant="filled"
                />
            </TableCell>
            <TableCell align="left" onClick={open}>{datetimeSimplifier(row.processed)}</TableCell>
            <TableCell align="left" onClick={open}>{user?.display ?? row.userId}</TableCell>
        </TableRow>
    );
};

export default MassiveMessageRow;
